import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {MRT_API_BASEPATH} from '../ssr/constants'
import {getValidToken} from './utils'
import {useCallback} from 'react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useAuthContext from '@salesforce/commerce-sdk-react/hooks/useAuthContext'

export const useTokenHelper = () => {
    const appOrigin = useAppOrigin(false)
    const {site, locale} = useMultiSite()
    const auth = useAuthContext()
    const {getTokenWhenReady} = useAccessToken()

    const getCustomerId = () => {
        const onClient = typeof window !== 'undefined'
        if (onClient) {
            return localStorage.getItem(`customer_id_${site.id}`)
        }
        return auth.get('customer_id')
    }

    const getOMSValidToken = async () => {
        const apiUrl = `${appOrigin}${MRT_API_BASEPATH}/get-auth-token-oms`
        const customerId = getCustomerId()
        const accessTokenKey = 'accessTokenOMS'
        const tokenExpirationKey = 'tokenExpirationOMS'
        const token = await getTokenWhenReady()
        return await getValidToken(
            apiUrl,
            accessTokenKey,
            tokenExpirationKey,
            locale.alias,
            customerId,
            token,
        )
    }

    const getMCValidToken = async () => {
        const apiUrl = `${appOrigin}${MRT_API_BASEPATH}/get-auth-token-marketing-cloud`
        const customerId = getCustomerId()
        const accessTokenKey = 'accessTokenMC'
        const tokenExpirationKey = 'tokenExpirationMC'
        const token = await getTokenWhenReady()
        return await getValidToken(
            apiUrl,
            accessTokenKey,
            tokenExpirationKey,
            locale.alias,
            customerId,
            token,
        )
    }

    const getSAPCPIValidToken = async () => {
        const apiUrl = `${appOrigin}${MRT_API_BASEPATH}/get-auth-token-sap-cpi`
        const customerId = getCustomerId()
        const accessTokenKey = 'accessTokenSAPCPI'
        const tokenExpirationKey = 'tokenExpirationSAPCPI'
        const token = await getTokenWhenReady()
        return await getValidToken(
            apiUrl,
            accessTokenKey,
            tokenExpirationKey,
            locale.alias,
            customerId,
            token,
        )
    }

    const getTrustPilotToken = async () => {
        const apiUrl =
            `${appOrigin}${MRT_API_BASEPATH}/get-trustpilot-access-token?siteId=` + site.id
        const customerId = getCustomerId()
        const accessTokenKey = 'accessTokenTrustpilot' + '_' + locale.alias
        const tokenExpirationKey = 'tokenExpirationTrustpilot' + '_' + locale.alias
        const token = await getTokenWhenReady()
        return await getValidToken(
            apiUrl,
            accessTokenKey,
            tokenExpirationKey,
            locale.alias,
            customerId,
            token,
        )
    }

    const fetchOMSValidToken = useCallback(async () => {
        return await getOMSValidToken()
    }, [])

    const fetchMCValidToken = useCallback(async () => {
        return await getMCValidToken()
    }, [])

    const fetchSAPCPIValidToken = useCallback(async () => {
        return await getSAPCPIValidToken()
    }, [])

    const fetchTrustPilotToken = useCallback(async () => {
        return await getTrustPilotToken()
    }, [])

    return {
        fetchOMSValidToken,
        fetchMCValidToken,
        fetchSAPCPIValidToken,
        fetchTrustPilotToken,
    }
}
